import React, { useMemo } from 'react'

import { Table } from '@domain-group/suit-theme'

import { PortalOptionValueModel } from '@models/types'

import PortalOptionValueActions from './PortalOptionValueActions'

const buildColumns = () => [
  {
    title: 'Option Title',
    dataKey: 'title',
  },
  {
    title: 'Subtitle',
    dataKey: 'subtitle',
  },
  {
    title: 'Node Name',
    dataKey: 'node_name',
  },
  {
    title: 'Value',
    dataKey: 'value',
  },
  {
    title: 'Actions',
    dataKey: 'id',
    cellProps: {
      width: 80,
      textAlign: 'center',
    },
    render: (_: unknown, portalOptionValue: PortalOptionValueModel) => (
      <PortalOptionValueActions portalOptionValue={portalOptionValue} />
    ),
  },
]

const PortalOptionValuesTable = (props: { portalOptionValues: PortalOptionValueModel[] }) => {
  const { portalOptionValues } = props

  const memoColumns = useMemo(() => buildColumns(), [portalOptionValues.length])

  return (
    <Table
      boxProps={{
        borderBottom: 'none',
        borderRadius: 'none',
        borderX: 'none',
        maxHeight: 800,
        overflowY: 'auto',
      }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      data={portalOptionValues}
      stickyHeader
    />
  )
}

export default React.memo(PortalOptionValuesTable)
